export const getUsers = (state) => {
  return state.user.users;
};
